export default __webpack_public_path__ + "static/bg-5bac3e025efb56136d9969179f4685ec.png";